import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PieItem } from "../../../../config/types";
import { AppThunk } from "../../..";

interface PieState{
    data:PieItem[],
    periods:string[]
}



const initialState:Partial<PieState>  = {}
export const pieMetrics = createSlice({
  name: "pieMetrics",
  initialState,
  reducers: {
    update: (_state, action: PayloadAction<PieState>) => {
      return action.payload;
    },
  },
});
export const { update } = pieMetrics.actions;
export const updatepieMetrics=(data:PieState):AppThunk=>  (dispatch)=>{
  dispatch(update(data));
}
export default pieMetrics.reducer;

